module.exports = __webpack_public_path__ + "img/conflict-confronter.75976c59.svg";